import type { FieldDef, SchemaIndex } from "@gjwtrack/query-language";
import { hashSlot, initials, userName } from "../lib/format.ts";

/** Square letter badge YouTrack shows next to an option value; colour from the element's colour slot. */
export function ValueBadge({ schema, def, value, size }: { schema: SchemaIndex; def: FieldDef; value: number | string; size?: number }) {
  const el = typeof value === "number" ? schema.elementsById.get(value) : undefined;
  const slot = el?.colorId ?? 0;
  const text = el?.name ?? String(value);
  return (
    <span className={`badge ${slot > 0 ? `chip-${((slot - 1) % 8) + 1}` : ""}`} style={size ? { width: size, height: size, fontSize: size * 0.5 } : undefined} title={def.name + ": " + text} aria-hidden>
      {initials(text, 1)}
    </span>
  );
}

/** Round avatar with initials, colour hashed from the name. */
export function Avatar({ schema, userId, size = 24 }: { schema: SchemaIndex | null; userId: number; size?: number }) {
  const name = userName(schema, userId);
  return (
    <span className={`badge round chip-${hashSlot(name)}`} style={{ width: size, height: size, fontSize: size * 0.42 }} title={name} aria-hidden>
      {initials(name)}
    </span>
  );
}
